<template>
  <div class="dropdown compact-container">
    <button id="ddlCompactMenu" class="btn px-4 btn-dropdown-actions" type="button" data-toggle="dropdown"
      aria-haspopup="true" aria-expanded="false">
      <div class="btn-dropdown-items dropdown-toggle">
        <div class="btn-dropdown-icon tag-badge">
          <span class="dot align-items-center d-flex justify-content-center">
            <em class="orange-icon-badge-align orange-icon" :class="selected.page.icon" />
          </span>
        </div>
        <span class="btn-dropdown-title">{{ selected.page.title }}</span>
      </div>
    </button>
    <div class="dropdown-menu dropdown-menu-custom shadow-lg" aria-labelledby="ddlCompactMenu">
      <button v-for="(item, index) in items" :key="index" class="dropdown-item dropdown-item-custom" type="button"
        @click="onSelect(item)">
        <div class="dropdown-menu-pages d-flex" :class="{ active: item.Id == selected.Id }">
          <div class="d-flex justify-content-center align-items-center">
            <em class="orange-icon-badge-align font-16 icon-inside mx-2" :class="item.page.icon" />
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <span class="font-12 font-weight-bold text-black">{{ item.page.title }}</span>
          </div>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompactTab',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    tabId: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      selected: {
        page: {},
      },
    };
  },
  mounted() {
    this.getSelectedTab(this.tabId);
  },
  methods: {
    onSelect(item) {
      this.selected = item;
      this.$emit('set-active-tab', this.selected);
    },
    getSelectedTab(tabId) {
      this.selected = this.items.find((x) => x.Id === tabId);
    },
  },
};
</script>

<style scoped>
.compact-container {}

.btn-dropdown-actions {
  border-radius: 6px;
  border: 1px solid #3f5b60;
  height: 3rem;
  background: #3f5b60;
  width: 100%;
}

.btn-dropdown-items {
  display: flex;
  flex-direction: row;
}

.btn-dropdown-actions .btn-dropdown-icon {
  margin-top: 7px;
}

.btn-dropdown-actions .btn-dropdown-items .btn-dropdown-title {
  color: #fff;
  margin-top: 4px;
  font-size: 17px;
  width: 100%;
  text-align: start;
}

.dropdown-menu-pages {
  padding: 20px 20px 20px 10px;
  height: 50px;
  background: #f2f2f2;
}

.dropdown-menu-pages.active {
  background: #ff7058;
}

.dropdown-menu-pages.active>div>span {
  color: #fff;
}

.dropdown-menu-pages.active>div>em {
  color: #fff;
}

.dropdown-menu-custom {
  padding: 0px !important;
  transform: none !important;
  width: 100% !important;
  top: 48px !important;
}

.dropdown-item-custom {
  padding: 0px 0px 2px 0px;
}

.dropdown-toggle:after {
  font-family: 'Font Awesome 5 Pro';
  content: '\f077';
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  opacity: 1;
  width: 20px;
  margin-right: 5px;
  border-top: none;
  margin-top: 4px;
}

.btn-dropdown-actions[aria-expanded='true'] .dropdown-toggle:after {
  font-family: 'Font Awesome 5 Pro';
  content: '\f078';
  font-size: 30px;
  font-weight: 900;
  color: #fff;
  opacity: 1;
  width: 20px;
  border-top: none;
}

.dropdown-item.active,
.dropdown-item:active {
  background-color: #fff !important;
  color: #3f5b60 !important;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  padding-bottom: 0.5%;
  border-radius: 26px;
  cursor: pointer;
}

.dot {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px #00000029;
}

.orange-icon {
  color: #ff7058;
  font-size: 11pt;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #11291b;
}

.icon-inside {
  color: #A5B3AD
}

@media screen and (max-width: 768px) {
  .btn-dropdown-title {
    font-size: 15px !important;
  }

  .dropdown-toggle:after {
    font-size: 19px !important;
    margin-top: 5px !important;
    margin-right: -5px !important;
  }

  .dropdown-menu-pages {
    padding: 9px 18px 13px 2px !important;
  }

  .dropdown-menu-pages span {
    font-size: 15px !important;
  }

  .btn-dropdown-items.dropdown-toggle {
    margin-left: -15px !important;
    margin-top: -4px !important;
  }
}

@media screen and (max-width: 540px) {
  .btn-dropdown-title {
    font-size: 13px !important;
    overflow-wrap: break-word !important;
  }

  .dropdown-toggle:after {
    font-size: 13px !important;
    margin-top: 5px !important;
    margin-right: -5px !important;
  }

  .dropdown-menu-pages {
    padding: 9px 18px 13px 2px !important;
  }

  .dropdown-menu-pages span {
    font-size: 12px !important;
  }

  .btn-dropdown-items.dropdown-toggle {
    margin-left: -15px !important;
    margin-top: -2px !important;
  }
}
</style>
